export enum AccessProfile {
    default = 'default',
    notShownInCarePath = 'notShownInCarePath',
    supervision = 'supervision',
}
